// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Expertise_wrap__YF9Sg","primary":"Expertise_primary__hKDjB","transparent":"Expertise_transparent__SqUxp"};